import styled from '@emotion/styled';
import { space } from 'folio-common-components';

export const Page = styled.div`
  max-width: 1150px;
  margin: auto;
  ${space([16], 'padding-horizontal')};
`;
